import { inject, Injectable } from '@angular/core';
import { Auth, authState, signOut, user, User } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Observable, of, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly auth = inject(Auth);
  private router = inject(Router);

  // Check current auth state (used by guard)
  checkAuthStatus(): Observable<boolean> {
    return authState(this.auth).pipe(
      take(1), // Take the first emission only
      switchMap(user => {
        console.log('Client App: Auth state checked, user:', user ? user.uid : 'null');
        return of(!!user); // Return true if user exists, false otherwise
      })
    );
  }

  async logout(): Promise<void> {
    await signOut(this.auth);
    console.log('Client App: Logged out.');
    await this.router.navigate(['/']); // Navigate to a local page
  }

  getUser(): Observable<User | null> {
    return user(this.auth);
  }

}
